/*
*
* File JS per la pagina AZIENDA
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './azienda.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

addEventListener('DOMContentLoaded', (evt) =>
{

});

//--------------------------------------------------------------------//